import { createSaga } from "../../utils/createSaga";
import { anamnezRoutine, userAnamnezRoutine } from "../routines/anamnezRoutine";

export default function* anamnezSaga() {
  yield createSaga(anamnezRoutine, "GET", "api/anamnez");
  yield createSaga(userAnamnezRoutine, "POST", "api/anamnez/save");
}
